// removed by extract-text-webpack-plugin
module.exports = {"container":"_1JJQbz1btasWrujJ","dark":"_3hQgRhin84WllOiZ","textArea":"_1QKVxkbxQrcKupQ6","content":"_3D7pvDJ4CRyDA5lP","editing":"_3cnh9lDuGSmLERNs"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/EditableTextArea.pcss
// module id = 470
// module chunks = 1